export const revenueAdjustmentHelperText = {
  status: 'Credit will be applied in next billing run at 4pm PST/3pm PDT',
  notes: 'Notes are only shown internally',
  description: 'Description will show on the customer facing PDF',
};
